// extracted by mini-css-extract-plugin
module.exports = {"welfare-gallery":"index_welfare-gallery_1eD6Z","activities":"index_activities_qtyij","item-title":"index_item-title_3ZJqO","item-content":"index_item-content_er4Ig"};